export default __webpack_public_path__ + "static/media/cruce-de-tandilia-2.7b6a5f4f.jpg";